import domPurify from 'dompurify'
import parse from 'html-react-parser'
import { getInvoiceStatusName } from 'mmfintech-backend-api'
import type { InvoiceResponse } from 'mmfintech-backend-api/types'
import { tr } from 'mmfintech-commons'
import './InvoicePreview.scss'

interface Props {
  status?: InvoiceResponse['status']
  content?: string
  onClose: () => void
}

function InvoicePreview({ status, content, onClose }: Props) {
  return (
    <div className='preview-wrapper' data-test='invoice-preview-modal'>
      <div className={'close-icon-row status-' + status?.toLowerCase()}>
        <span>
          <span className='status-title'>{tr('PORTAL.INVOICES.PREVIEW.STATUS', 'Invoice status')}: </span>
          <span>{getInvoiceStatusName(status)}</span>
        </span>

        <div className='close-icon-wrap'>
          <span className='invoice-preview-close-icon' onClick={onClose} />
        </div>
      </div>

      <div className='preview-content'>{parse(domPurify.sanitize(content))}</div>
    </div>
  )
}

export default InvoicePreview
